import * as React from 'react';

import { UserProvider } from '../context/user.context';

/** Providers for logged-out pages (e.g. sign in). Must be rendered inside `AppProviders`. */
export const UnauthenticatedProviders: React.FC<React.PropsWithChildren> = ({ children }) => (
  <UserProvider authenticated={false}>{children}</UserProvider>
);
